var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./documentPackage.constants";
export var useGetAll = (_a = generateHooks(GENERATOR_PARAMS), _a.useGetAll), useDetail = _a.useDetail, usePaged = _a.usePaged, useUpdate = _a.useUpdate, useCount = _a.useCount;
